
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import AkkhorLayout from "../layout/akkhor";
import Axios from "axios";
import { URL_LIST_ALL } from "../configs/api";
import { useSelector } from "react-redux";
import { Table } from "react-bootstrap";
import Pagination from "react-js-pagination";
import Loading from "../component/Loading";

const LIMIT = 20;

const jsonPreviewStyle = {
  maxHeight: 280,
  maxWidth: 420,
  overflow: "auto",
  whiteSpace: "pre-wrap",
  wordBreak: "break-word",
  fontSize: 12,
  marginTop: 8,
  marginBottom: 0,
};

const formatJson = (value) => {
  if (value === null || value === undefined || value === "") return "";
  if (typeof value === "string") return value;
  return JSON.stringify(value, null, 2);
};

const renderJsonData = (value) => {
  const text = formatJson(value);
  if (!text) return "";

  return (
    <details>
      <summary className="text-primary" style={{ cursor: "pointer" }}>Xem dữ liệu</summary>
      <pre style={jsonPreviewStyle}>{text}</pre>
    </details>
  );
};

const renderUserInfo = (value, log) => {
  if (!value || typeof value !== "object") return value || log.user_id || "";

  const { fullname, code, email } = value;

  return (
    <div>
      {fullname ? <div>{fullname}</div> : ""}
      {code ? <div>Mã: {code}</div> : ""}
      {email ? <div>{email}</div> : ""}
    </div>
  );
};

const renderDate = (value) => {
  if (!value) return "";

  const date = typeof value === "number" ? new Date(value * 1000) : new Date(value);
  if (Number.isNaN(date.getTime())) return value;

  return date.toLocaleString("vi-VN", {
    hour: "2-digit",
    minute: "2-digit",
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });
};

export default function DanhSachLog() {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [totalPage, setTotalPage] = useState(1);
  const [totalRecord, setTotalRecord] = useState(0);
  const [filters, setFilters] = useState({});
  const [tablename, setTablename] = useState("");
  const [tableId, setTableId] = useState("");
  const [userInfo, setUserInfo] = useState({
    fullname: "",
    code: "",
    email: "",
  });
  const [filterShow, setFilterShow] = useState(false)
  const { user } = useSelector((state) => state.auth);

  useEffect(() => {
    let mounted = true;

    const getLogs = async () => {
      setLoading(true);
      const query = new URLSearchParams({
        page,
        limit: LIMIT,
      });

      Object.keys(filters).forEach((key) => {
        const value = filters[key];

        if (!value) return;

        query.append(key, typeof value === "object" ? JSON.stringify(value) : value);
      });

      const config = {
        headers: {
          Authorization: "Bearer " + user.access_token,
          "Content-Type": "application/json; charset=UTF-8",
        },
      };

      try {
        const res = await Axios.get(URL_LIST_ALL + "logs?" + query.toString(), config);

        if (!mounted) return;

        if (res.data.status === "success") {
          const responseTotalPage = Number(res.data.totalPage || 1);
          const responsePage = Number(res.data.page || page);

          setLogs(Array.isArray(res.data.data) ? res.data.data : []);
          setTotalPage(responseTotalPage);
          setPage(responsePage);
          setTotalRecord(Number(res.data.total || responseTotalPage * LIMIT));
        } else {
          setLogs([]);
          setTotalPage(1);
          setTotalRecord(0);
          console.log(res.data.message);
        }
      } catch (err) {
        if (mounted) {
          setLogs([]);
          setTotalPage(1);
          setTotalRecord(0);
        }
        console.log(err);
      } finally {
        if (mounted) setLoading(false);
      }
    };

    getLogs();

    return () => {
      mounted = false;
    };
  }, [filters, page, user]);

  const handleSubmit = (e) => {
    e.preventDefault();
    const nextFilters = {};

    const nextUserInfo = {
      fullname: userInfo.fullname.trim(),
      code: userInfo.code.trim(),
      email: userInfo.email.trim(),
    };

    if (tablename.trim() !== "") nextFilters.tablename = tablename.trim();
    if (tableId.trim() !== "") nextFilters.tableid = tableId.trim();
    if (Object.values(nextUserInfo).some(Boolean)) nextFilters.user_info = nextUserInfo;

    setPage(1);
    setFilters(nextFilters);
  };

  const handleResetFilter = () => {
    setTablename("");
    setTableId("");
    setUserInfo({
      fullname: "",
      code: "",
      email: "",
    });
    setPage(1);
    setFilters({});
  };

  const columns = [
    { name: "_id", label: "ID" },
    { name: "user_info", label: "User", render: renderUserInfo },
    { name: "tablename", label: "Tên bảng" },
    { name: "tableid", label: "ID bảng" },
    { name: "action", label: "Thao tác" },
    { name: "olddata", label: "Dữ liệu cũ", render: renderJsonData },
    { name: "newdata", label: "Dữ liệu mới", render: renderJsonData },
    { name: "update_value", label: "Giá trị cập nhật", render: renderJsonData },
    { name: "created_at", label: "Thời gian", render: renderDate },
  ];

  const renderCell = (log, column) => {
    const value = log[column.name];
    return column.render ? column.render(value, log) : value;
  };

  return (<AkkhorLayout idrole="dashboard">
    <div className="breadcrumbs-area">
      <ul>
        <li>
          <Link to="/">Trang chủ</Link>
        </li>
        <li>
          Logs hệ thống
        </li>
      </ul>
    </div>
    <div className="card card-filter mb-3">
      <div className="card-header">
        <div className="d-flex">
          <div className="me-auto">
            <h3 className="title">Tìm kiếm</h3>
          </div>
          <button type="button" className="btn btn-sm btn-light" onClick={() => setFilterShow(!filterShow)}><span className={!filterShow ? "fas fa-angle-down" : "fas fa-angle-up"}></span></button>
        </div>
      </div>
      <div className={filterShow ? "card-body" : 'hidden-filter'}>

        <form className="new-added-form" method="get" >
          <div className="row">
            <div className="col-lg-3 col-md-6 col-sm-6 col-12 form-group">
              <label>Tên bảng </label>
              <input type="text" placeholder="Tìm tên bảng" value={tablename} onChange={(e) => setTablename(e.target.value)} className="form-control height32" autoComplete="off" />
            </div>
            <div className="col-lg-3 col-md-6 col-sm-6 col-12 form-group">
              <label>ID bảng </label>
              <input type="text" placeholder="ID bảng" value={tableId} onChange={(e) => setTableId(e.target.value)} className="form-control height32" autoComplete="off" />
            </div>
            <div className="col-lg-3 col-md-6 col-sm-6 col-12 form-group">
              <label>Họ tên </label>
              <input type="text" placeholder="Họ tên" value={userInfo.fullname} onChange={(e) => setUserInfo({ ...userInfo, fullname: e.target.value })} className="form-control height32" autoComplete="off" />
            </div>
            <div className="col-lg-3 col-md-6 col-sm-6 col-12 form-group">
              <label>Mã nhân sự </label>
              <input type="text" placeholder="Mã nhân sự" value={userInfo.code} onChange={(e) => setUserInfo({ ...userInfo, code: e.target.value })} className="form-control height32" autoComplete="off" />
            </div>
            <div className="col-lg-3 col-md-6 col-sm-6 col-12 form-group">
              <label>Email </label>
              <input type="text" placeholder="Email" value={userInfo.email} onChange={(e) => setUserInfo({ ...userInfo, email: e.target.value })} className="form-control height32" autoComplete="off" />
            </div>

            <div className="col-12 ">
              <button type="submit" onClick={handleSubmit} className="btn-fill-sm btn-gradient-yellow btn-hover-bluedark">Lọc</button>
              <button type="button" onClick={handleResetFilter} className="btn btn-sm btn-secondary ms-2">Xóa lọc</button>
            </div>
          </div>
        </form>
      </div>
    </div>

    <div className="w-100 d-flex justify-content-between align-items-center">
      <div>
        Trang {page}/{totalPage}
        {totalRecord ? " - Tìm được khoảng: " + totalRecord + " dữ liệu" : ""}
      </div>
      {loading && (<Loading />)}
    </div>

    <Table striped bordered hover className="d-none d-md-table mt-2">
      <thead>
        <tr>
          {columns.map((column) => (
            <th key={column.name}>{column.label}</th>
          ))}
        </tr>
      </thead>
      <tbody>
        {logs.length > 0 ? logs.map((log) => (
          <tr key={log._id}>
            {columns.map((column) => (
              <td key={column.name}>{renderCell(log, column)}</td>
            ))}
          </tr>
        )) : (
          <tr>
            <td colSpan={columns.length} className="text-center">Không có dữ liệu</td>
          </tr>
        )}
      </tbody>
    </Table>

    <div className="d-block d-md-none table-mobile mt-2">
      <div className="w-100 list">
        {logs.length > 0 ? logs.map((log) => (
          <div className="list-item shadow" key={log._id}>
            {columns.map((column) => (
              <div className="w-100 d-row d-flex" key={column.name}>
                <div className="item-left">{column.label}</div>
                <div className="item-right">{renderCell(log, column)}</div>
              </div>
            ))}
          </div>
        )) : (
          <div className="list-item shadow text-center">Không có dữ liệu</div>
        )}
      </div>
    </div>

    {totalPage > 1 && (
      <Pagination
        activePage={page}
        itemsCountPerPage={LIMIT}
        totalItemsCount={totalRecord}
        pageRangeDisplayed={5}
        itemClass="page-item"
        linkClass="page-link"
        prevPageText="<"
        nextPageText=">"
        onChange={setPage}
      />
    )}

    <div className="col-12 p-5"></div>

  </AkkhorLayout>);
}
